export const RFP_RATE_TYPE_OPTIONS = [
  {
    value: 'rfp_lane_carrier_line_haul_rpm',
    label: 'RPM',
  },
  {
    value: 'rfp_lane_carrier_line_haul_flat',
    label: 'Linehaul',
  },
  {
    value: 'rfp_lane_carrier_all_in',
    label: 'All In',
  },
]
